<template>
<div class="form-grid">
        <small class="tx-lightgrey-1" style="font-size: calc(0.2vw + 0.60rem)">
            Los campos marcados con <strong class="text-dark">*</strong> son requeridos
        </small>
        <div class="form-group col-16">
            <label class="form-label" for="">Nombre completo*</label>
            <ValidationProvider name="nombre completo" rules="required|max:100" v-slot="{ errors }">
                <input
                        v-model="filters.name"
                        class="form-input"
                        :class="{'is-invalid': errors[0]}"
                        type="text"
                        />
                <span class="tx-red-danger">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
        <div class="form-group col-16">
            <label class="form-label" for="">Correo electrónico*</label>
                <ValidationProvider name="correo electrónico" rules="required|email" v-slot="{ errors }">

                <input v-model="filters.email"
                        class="form-input" type="email"
                        :class="{'is-invalid': errors[0]}"
                        />
                <span class="tx-red-danger">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
        <div class="form-group col-16">
            <label class="form-label" for="">Celular*</label>
            <ValidationProvider name="celular" rules="required" v-slot="{ errors }">
                <the-mask v-model="filters.phone"
                        class="form-input"
                        type="text"
                        placeholder="##-##-##-##-##"
                        :masked="false" mask="##-##-##-##-##"
                        :class="{'is-invalid': errors[0]}"
                        ></the-mask>
                <span class="tx-red-danger">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
</div>
</template>
<script>
import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate";
import es from 'vee-validate/dist/locale/es.json';

import * as rules from "vee-validate/dist/rules";

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});
localize('es', es);

export default {
    components:{
        ValidationObserver,
        ValidationProvider
    },
    props: {
        filters: {
            type: Object,
            required: true
        }
    }
}
</script>
